import React, { useState, useEffect } from "react";
import configData from "../config/config.json";
import { Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import FundTransferView from "../components/FundTransferView";
import { useHistory } from "react-router-dom";
import { tovalidateExpdate } from "../core/validationRules";
import toFetchIDValue from '../data/IdTypeCheck';
import helper from "../data/Helper";
import Loading from "./Loading";


var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse("8080808080808080");
let iv = CryptoJS.enc.Utf8.parse("8080808080808080");

const FundTransfer = () => {
  let history = useHistory();

  configData.RefferenceNo = localStorage.getItem("Ref");
  const [showLoading, setShowLoading] = useState(false);

  const [ftdetails, setftdetails] = useState({
    transferFrom: "",
    CreditAcntNO: "",
    CreditAbleAcntNO: "",
    pricing: "",
    transferto: "",
    Nameancnt: localStorage.getItem('CFN').slice(0, 19),
    CreditCardnumber: "",
    Amount: null,
  });

  useEffect(() => {

    if (tovalidateExpdate(new Date().getMinutes())) {
      if (configData.RefferenceNo) {
        if (configData.RefferenceNo) {
          const requestBody = {
            //new changes passing details to save at verification
            referenceno: configData.RefferenceNo,
            num: localStorage.getItem("nricval"),
          };
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              "Access-Control-Allow-Headers": "Content-Type",
              "Cache-Control": "no-cache", //for IE issues
              Pragma: "no-cache",
              Authorization: "Maybank" + " " + localStorage.getItem("tkn"),
            },
            body: JSON.stringify(requestBody),
          };

          setShowLoading(true);

          let url = getFTDataURL();

          fetch(url, requestOptions)
            .then(async (response) => {

              setShowLoading(false);
              const data = await response.json();
              if (!data.didError) {
                if (data.model.fields) {
                  if (data.model.fields.Fields) {
                    setftdetails(data.model.fields.Fields);
                    window.scrollTo(0, 0);
                  }
                }
              } else {
              }
            })
            .catch((err) => {
              setShowLoading(false);
              console.log(err);
            });
        }
      } else {
        alert("This session has timed out for your security.Please try again");
        helper.toHomeScreen();
      }
    } else {
      alert("This session has timed out for your security.");
      helper.toHomeScreen();
    }
  }, []);


  if (!ftdetails) {
    return false;
  } else {
    let data = ftdetails.FT1;
    if (data) {
      if (data.CreditAcntNO) {
        configData.checkCCAcntFlag = true;
      } else if (data.CreditAbleAcntNO) {
        configData.checkCAAcntFlag = true;
      }

      if (data.CreditCardnumber) {
        try {
          configData.decrypt = CryptoJS.AES.decrypt(
            data.CreditCardnumber,
            key,
            { iv: iv }
          );
          configData.decrypt = configData.decrypt.toString(CryptoJS.enc.Utf8);
        } catch (ex) {
          configData.decrypt = data.CreditCardnumber;
          console.log("ex", ex);
        }
      } else {
        configData.decrypt = data.CreditCardnumber;
      }

      if (data.CreditAcntNO) {
        configData.decrypt1 = CryptoJS.AES.decrypt(data.CreditAcntNO, key, {
          iv: iv,
        });
        configData.decrypt1 = configData.decrypt1.toString(CryptoJS.enc.Utf8);
      } else {
        configData.decrypt1 = data.CreditAcntNO;
      }

      if (data.CreditAbleAcntNO) {
        configData.decrypt2 = CryptoJS.AES.decrypt(data.CreditAbleAcntNO, key, {
          iv: iv,
        });
        configData.decrypt2 = configData.decrypt2.toString(CryptoJS.enc.Utf8);
      } else {
        configData.decrypt2 = data.CreditAbleAcntNO;
      }

      setftdetails({
        Nameancnt: data.Nameancnt,
        transferFrom: data.transferFrom,
        CreditAcntNO: configData.decrypt1,
        CreditAbleAcntNO: configData.decrypt2,
        pricing: data.pricing,
        transferto: data.transferto,
        Nameancnt: data.Nameancnt,
        CreditCardnumber: configData.decrypt,
        Amount: Number(data.Amount),
      });
    }
  }

  const getFTDataURL = () => {
    let baseUrl = configData.GET_FTDATA_PROD;

    if (configData.SERVER_STATUS === 'SIT') {
      baseUrl = configData.GET_FTDATA_SIT;
    }
    else if (configData.SERVER_STATUS === 'UAT') {
      baseUrl = configData.GET_FTDATA;
    }
    else {
      baseUrl = configData.GET_FTDATA_PROD;
    }

    return baseUrl;
  }


  const getSaveURL = () => {
    let baseUrl = configData.URL_SAVE_FT_PROD;

    if (configData.SERVER_STATUS === 'SIT') {
      baseUrl = configData.URL_SAVE_FT_SIT;
    }
    else if (configData.SERVER_STATUS === 'UAT') {
      baseUrl = configData.URL_SAVE_FT;
    }
    else {
      baseUrl = configData.URL_SAVE_FT_PROD;
    }
    return baseUrl;
  }


  // const getPromoCode = (transferFrom, selectedPricing) => {

  //   const sc = localStorage.getItem('p');
  //   let result = '';
  //   if (transferFrom === 'Credit Card Account') {
  //     if (sc === configData.SRC_CODE_HNW) {
  //       result = toFetchIDValue("PRICINGPROMOHNW", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT03) { //810203
  //       result = toFetchIDValue("PRICINGPROMO", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT04) { //810204
  //       result = toFetchIDValue("PRICINGPROMO", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT05) { //810205
  //       result = toFetchIDValue("PRICINGPROMO", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT06) { //810206
  //       result = toFetchIDValue("PRICINGPROMO", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT) { //810208
  //       result = toFetchIDValue("PRICINGPROMO", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_OUTSIDERS) { //810209 SEPT9th2023
  //       //Create new FT pre login url tagged to source code 810209 to support FT campaign targeting Revolvers outside Maybank
  //       // https://apply.maybank.com.sg/dcofmcca?p=345jNwy1Pxzr94tsjnvuHH70gqpql6b4xmmlaLUiZ8by

  //       result = toFetchIDValue("PRICINGPROMOMBANKOUTSIDERS", selectedPricing)
  //     }
  //     else {
  //       result = 'NA';
  //     }
  //   }
  //   else {
  //     result = 'NA';
  //   }
  //   return result;
  // }

  // const getSchemeCode = (transferFrom, selectedPricing) => {

  //   const sc = localStorage.getItem('p');

  //   let result = 'NA';
  //   if (transferFrom === "Credit Card Account") {
  //     result = 'NA';
  //   }
  //   else {
  //     if (sc === configData.SRC_CODE_HNW) { //HNw Campaign 810207
  //       result = toFetchIDValue("PRICINGSCHMEHNW", selectedPricing);
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT03) {  //810203
  //       result = toFetchIDValue("PRICINGCAFTSCHME", selectedPricing)
  //     } else if (sc === configData.SRC_CODE_CCFT04) {  //810204
  //       result = toFetchIDValue("PRICINGCAFTSCHME", selectedPricing)
  //     } else if (sc === configData.SRC_CODE_CCFT05) {  //810205
  //       result = toFetchIDValue("PRICINGCAFTSCHME", selectedPricing)
  //     } else if (sc === configData.SRC_CODE_CCFT06) {  //810206
  //       result = toFetchIDValue("PRICINGCAFTSCHME", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_CCFT) {  //810208
  //       result = toFetchIDValue("PRICINGCAFTSCHME", selectedPricing)
  //     }
  //     else if (sc === configData.SRC_CODE_OUTSIDERS) {  //810209 SEPT9th2023
  //       result = toFetchIDValue("PRICINGSCHMEMBANKOUTSIDERS", selectedPricing)
  //     }
  //   }

  //   return result;
  // }

  // const getSourceCode = (transferFrom) => {

  //   //event.values.transferFrom === "Credit Card Account" ? configData.SRC_CODE_CCFT : configData.SRC_CODE_CAFT,
  //   let result = '';
  //   const sc = localStorage.getItem('p');
  //   if (sc === configData.SRC_CODE_HNW) {
  //     result = configData.SRC_CODE_HNW;
  //   }
  //   else if (sc === configData.SRC_CODE_CCFT) {
  //     result = configData.SRC_CODE_CCFT;
  //   } else if (sc === configData.SRC_CODE_CCFT03) {
  //     result = configData.SRC_CODE_CCFT03;
  //   } else if (sc === configData.SRC_CODE_CCFT04) {
  //     result = configData.SRC_CODE_CCFT04;
  //   } else if (sc === configData.SRC_CODE_CCFT05) {
  //     result = configData.SRC_CODE_CCFT05;
  //   } else if (sc === configData.SRC_CODE_CCFT06) {
  //     result = configData.SRC_CODE_CCFT06;
  //   }
  //   else if (sc === configData.SRC_CODE_OUTSIDERS) {
  //     result = configData.SRC_CODE_OUTSIDERS;
  //   }
  //   else {
  //     result = configData.SRC_CODE_CCFT;
  //   }

  //   return result;
  // }



  const handleSubmit = (event) => {
    setShowLoading(true);
    if (event.isValid) {
      let countset = 1;
      const requestBody = {
        count: countset,
        FT1: {
          transferFrom: 'DCMCA',
          Nameancnt: event.values.Nameancnt,// required
          PROMO_CODE: 'DCMCA',// required
          CreditCardnumber: event.values.CreditAbleAcntNO,// required
          CreditAbleAcntNO: event.values.CreditAbleAcntNO,// required
          CreditAcntNO: "DCMCA",
          pricing: 'DCMCA Pricing',
          transferto: 'DCMCA',
          transfertoid: 'DCMCA',
          Amount: 'DCMCA',
          PRODUCT_TYPE: 'DCMCA',
          SCHEME_CODE: 'DCMCA',
          SOURCE_CODE: 'DCMCA'
        },
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Headers": "Content-Type",
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Authorization: "Maybank" + " " + localStorage.getItem("tkn"),
        },
        body: JSON.stringify(requestBody),
      };

      let url = getSaveURL();

      fetch(
        url +
        "?refno=" +
        configData.RefferenceNo +
        "&prodtype=" +
        configData.PRODUCT_TYPE,
        requestOptions
      )
        .then(async (response) => {
          setShowLoading(false);
          const data = await response.json();
          if (!data.didError) {
            localStorage.setItem("RefNEW", data.refNo);

            history.push("ReviewDetails");
          } else {
            alert("Something went wrong, please try again");
          }
        })
        .catch((error) => {
          setShowLoading(false);
          alert("Some thing went wrong! please try again");
          helper.toHomeScreen();
        });
    }

  };



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="container mt-5">
          <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
        </div>

        <div className="demo-section k-content dynmicwhitecntr  DynamicFields">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="row example-wrapper">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="card-block"></div>
                <Form
                  onSubmitClick={handleSubmit}
                  initialValues={ftdetails}
                  key={JSON.stringify(ftdetails)}
                  render={(formRenderProps) => (
                    <FormElement>
                      <fieldset className={"k-form-fieldset"}>
                        <div
                          className="row around-xs inputPairelementVisible"
                          style={{ marginTop: "1.5rem" }}
                        >
                          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <legend className={"k-form-legend"}>
                              {configData.HDR_FT_DETAILS}
                            </legend>
                          </div>
                        </div>
                        <FundTransferView />
                        <div
                          className="text-right"
                          style={{ marginTop: "1rem" }}
                        >
                          <Button
                            className="btnMaybank"
                            type={"submit"}
                            primary={true}
                            disabled={!formRenderProps.valid}
                          >
                            {configData.ON_NEXT}
                          </Button>
                        </div>
                      </fieldset>

                      <br></br>
                    </FormElement>
                  )}
                />
                {showLoading && <Loading />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundTransfer;
